import Typography from "../Typography/Typography";
import Divider from "../Divider/Divider";
import styles from "./Modal.module.scss";

import ModalImage from "../../assets/modalWarning.svg";
import ModalImageSuccess from "../../assets/modalSuccess.svg";
import ModalCloseIcon from "../../assets/close.svg";

const Modal = (props) => {
	const {
		title = "",
		onClose,
		children,
		hasCloseIcon = false,
		isSuccess = false,
	} = props;

	return (
		<div className={styles.modalContainer}>
			<div className={styles.modalContent}>
				{isSuccess ? (
					<img
						src={ModalImageSuccess}
						className={styles.modalIcon}
						alt="modal-img"
					></img>
				) : (
					<img
						src={ModalImage}
						className={styles.modalIcon}
						alt="modal-img"
					></img>
				)}

				{hasCloseIcon && (
					<img
						src={ModalCloseIcon}
						alt="close-icon"
						className={styles.modalCloseIcon}
						onClick={onClose}
					></img>
				)}
				<Typography variant="h4" className={styles.modalTitle}>
					{title}
				</Typography>
				<Divider className={styles.modalDivider}></Divider>
				{children}
			</div>
		</div>
	);
};

export default Modal;
